<form [formGroup]="form" autocomplete="off" class="form-field-group">
  <mat-form-field floatLabel="always" class="form-field-right">
    <mat-label>Age</mat-label>
    <input type="number" matInput formControlName="years" min="0" spellcheck="false">
    <span matSuffix class="medium-emphasis">years</span>
  </mat-form-field>
  <mat-form-field floatLabel="never" class="form-field-right">
    <input type="number" matInput formControlName="months" min="0" spellcheck="false">
    <span matSuffix class="medium-emphasis">months</span>
  </mat-form-field>
  <mat-form-field floatLabel="never" class="form-field-right">
    <input type="number" matInput formControlName="days" min="0" spellcheck="false">
    <span matSuffix class="medium-emphasis">days</span>
  </mat-form-field>
</form>